'use strict';

import React from 'react';

export default function IconClaim (props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.46354 15.5833C12.3267 15.5833 15.4583 12.412 15.4583 8.5C15.4583 4.58799 12.3267 1.41667 8.46354 1.41667C4.60042 1.41667 1.46875 4.58799 1.46875 8.5C1.46875 12.412 4.60042 15.5833 8.46354 15.5833Z" stroke="#757575" strokeWidth="0.8"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.9612 6.72914L10.912 7.26038C11.0218 7.48237 11.0868 7.75829 11.0868 8.05729C11.0868 8.79077 10.6954 9.38542 10.2125 9.38542C9.72955 9.38542 9.33811 8.79077 9.33811 8.05729V8.04499V6.72914L11.9612 5.40102V6.72914ZM7.58936 8.05729C7.58936 8.79077 7.19789 9.38542 6.71501 9.38542C6.23212 9.38542 5.84066 8.79077 5.84066 8.05729C5.84066 7.75829 5.9057 7.48237 6.01548 7.26039L4.96631 6.72917V5.40104L7.58936 6.72917V8.05729ZM5.84058 12.927C5.84058 12.0416 6.71493 10.2708 8.46362 10.2708C10.2123 10.2708 11.0867 12.0416 11.0867 12.927C10.6495 12.4843 9.33797 12.0416 8.46362 12.0416C7.58927 12.0416 6.27775 12.4843 5.84058 12.927Z" fill="#757575"/>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/ui/Icons/IconClaim.jsx